import ContactUsComp from "./components/contact_us_comp"
// import PageComponent from '../../components/page/page_comp';
import PageV2Component from "../../components/page_v2/page_v2_comp";
import { ContactUsContextProvider } from "./state/contact_us_state";
const ContactUsPage = () => {
    // return PageComponent({
    //     content:  <ContactUsComp />,
    //     showFooter: false,
    //   })
    return <PageV2Component hideFooter={true}>
      <ContactUsContextProvider>
        <ContactUsComp />
      </ContactUsContextProvider>
    </PageV2Component>
}

export default ContactUsPage